import { AlertCircle, CheckCircle, Clock } from "lucide-react";

import { STORE_RECONCILIATION_STATUS } from "../../constants/status";

type Status = keyof typeof STORE_RECONCILIATION_STATUS;

const CONFIG: Record<Status, { label: string; icon: typeof AlertCircle; className: string }> = {
  [STORE_RECONCILIATION_STATUS.ABERTO]: {
    label: "Aberto",
    icon: AlertCircle,
    className: "bg-rose-100 text-rose-700 border-rose-200",
  },
  [STORE_RECONCILIATION_STATUS.AGUARDANDO]: {
    label: "Aguardando",
    icon: Clock,
    className: "bg-yellow-100 text-yellow-700 border-yellow-200",
  },
  [STORE_RECONCILIATION_STATUS.FECHADO]: {
    label: "Fechado",
    icon: CheckCircle,
    className: "bg-slate-100 text-slate-700 border-slate-200",
  },
};

export function StatusBadge({ status }: { status: Status }) {
  const cfg = CONFIG[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cfg.className}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      {cfg.label}
    </span>
  );
}
